const numberFormats = {
    en: {
        currency: { style: "currency", currency: "USD" }
    },
    fr: {
        currency: { style: "currency", currency: "EUR" }
    },
    ar: {
        currency: { style: "currency", currency: "USD", currencyDisplay: "code" }
    }
};

export default numberFormats